import React, { FC, ReactNode } from 'react';
import styles from './TabletFilterLabel.module.scss';

export interface FilterLabelProps {
  children: ReactNode;
  htmlFor?: string;
  size?: 'normal' | 'small';
  className?: string;
}

export const TabletFilterLabel: FC<FilterLabelProps> = ({
  children,
  htmlFor,
  size = 'normal',
  className,
}) => {
  const labelClass = size === 'small' ? styles.smallLabel : styles.label;

  return (
    <label htmlFor={htmlFor} className={`${labelClass} ${className || ''}`}>
      {children}
    </label>
  );
};
